import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
const NoIssues = () => {
    const { t } = useTranslation();
    return _jsxs("div", { className: "content content--no-issues-page content--no-issues-page--inline d-flex flex-row justify-content-center align-items-center", children: [_jsx("span", { className: "content__picture content__picture--small", children: "\u00A0" }), _jsxs("div", { className: "content__text-wrapper", children: [_jsx("h2", { className: "content__title", children: t('noIssues') }), _jsxs("p", { className: "content__text", children: [t('siteName'), " ", t('didntFindIssues')] })] })] });
};
export default NoIssues;
